import { render, staticRenderFns } from "./ThemplateMedicalRecord.vue?vue&type=template&id=5e2e0378&scoped=true"
import script from "./ThemplateMedicalRecord.vue?vue&type=script&lang=js"
export * from "./ThemplateMedicalRecord.vue?vue&type=script&lang=js"
import style0 from "./ThemplateMedicalRecord.vue?vue&type=style&index=0&id=5e2e0378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2e0378",
  null
  
)

export default component.exports